import { useState } from "react";
import { Share2, Check } from "lucide-react";
import { toast } from "sonner";
import { CANONICAL_BASE } from "./Seo";

async function copyLink(url) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(url);
      return true;
    }
  } catch {
    /* falls through to the legacy path */
  }
  const field = document.createElement("textarea");
  field.value = url;
  field.setAttribute("readonly", "");
  field.style.position = "fixed";
  field.style.opacity = "0";
  document.body.appendChild(field);
  field.select();
  const ok = document.execCommand("copy");
  document.body.removeChild(field);
  return ok;
}

/** Native share with a copy-link fallback. Always shares the canonical public URL. */
export const ShareButton = ({ path, title, text, testid = "share-button" }) => {
  const [done, setDone] = useState(false);
  const url = `${CANONICAL_BASE}${path}`;

  const onShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, text, url });
        return;
      } catch (e) {
        if (e && e.name === "AbortError") return;
      }
    }
    const ok = await copyLink(url);
    if (ok) {
      setDone(true);
      toast.success("Lien copié");
      setTimeout(() => setDone(false), 2000);
    } else {
      toast.error("Copie impossible. Lien : " + url);
    }
  };

  return (
    <button
      type="button"
      onClick={onShare}
      data-testid={testid}
      aria-label={`Partager : ${title}`}
      className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-black/40 px-4 py-2 text-xs uppercase tracking-[0.18em] text-neutral-200 backdrop-blur-md transition-colors duration-200 hover:border-[#FF2E63] hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#FF2E63]"
    >
      {done ? <Check size={14} className="text-[#FF2E63]" /> : <Share2 size={14} />}
      <span>{done ? "Lien copié" : "Partager"}</span>
    </button>
  );
};

export default ShareButton;
